import styled, { css } from "styled-components";

export interface IcardStyled{
  selected: boolean;
  disableOptions: boolean;
}

const Card = styled.div<IcardStyled>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    width: 100%;
    min-height: 70px;

    margin: 8px 0;
    padding-left: 8px;

    box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
    background: ${(props) => props.selected ? "var(--main-color)" : "var(--card-background)"};
    
    position: relative;
    cursor: pointer;

    border-radius: 4px;

    transition: 200ms ease;

    .btn-option{
        display: ${(props) => props.disableOptions ? "none" : "block" };
    }

    ${(props) => props.disableOptions ? css`
        pointer-events: none;
    ` : "" }
    
    &:hover{
        background: ${(props) => props.selected ? "var(--purple-darker)" : "var(--border-color)"};
    }

    .card-body{
        font-weight: bold;
        color: ${(props) => props.selected ? "white" : "unset"};
        overflow: hidden;
        width: 95%;

        span{
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }
    }

    .card-footer{
        font-size: 0.7rem;
        color: ${(props) => props.selected ? "white" : "unset"};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }


    &:hover{
        .icon-options{
            .card-canvas-options-move{
                display: block;
            }
        }
    }

    .icon-options{
        position: absolute;
        top: -4px;
        right: -8px;
        display: flex;
        align-items: center;

        .card-canvas-options-move{
            margin-right: -10px;
            display: none;
        }
    }

    
`;


export default Card;
